import { useState, useEffect } from "react";
import { ChevronDown, ChevronRight, Inbox } from "lucide-react";
import { useInbox, useInboxActions } from "@/hooks/useInbox";
import { useConceptList } from "@/hooks/useConcepts";
import { InboxCard } from "./InboxCard";

export function InboxSection() {
  const { data: items } = useInbox();
  const { data: concepts } = useConceptList();
  const { assignItem, dismissItem, deferItem } = useInboxActions();
  const [expanded, setExpanded] = useState(false);

  const count = items?.length ?? 0;

  // Auto-expand when items exist
  useEffect(() => {
    if (count > 0) setExpanded(true);
  }, [count]);

  if (count === 0 && !expanded) return null;

  return (
    <div className="mb-6">
      <button
        onClick={() => setExpanded(!expanded)}
        className="flex items-center gap-2 text-sm font-semibold text-muted-foreground hover:text-foreground transition-colors mb-2"
      >
        {expanded ? <ChevronDown className="size-4" /> : <ChevronRight className="size-4" />}
        <Inbox className="size-4" />
        Research Inbox
        {count > 0 && (
          <span className="rounded-full px-1.5 py-0.5 text-[10px] font-medium" style={{ background: "rgba(245,158,11,0.15)", color: "#f59e0b" }}>
            {count}
          </span>
        )}
      </button>

      {expanded && (
        <div className="grid gap-3 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
          {items?.map((item) => (
            <InboxCard
              key={item.id}
              item={item}
              concepts={concepts ?? []}
              onAssign={(itemId, conceptId, workingSetId) =>
                assignItem.mutate({ itemId, concept_id: conceptId, working_set_id: workingSetId })
              }
              onDismiss={(itemId) => dismissItem.mutate(itemId)}
              onDefer={(itemId) => deferItem.mutate(itemId)}
            />
          ))}
          {count === 0 && (
            <p className="col-span-full text-xs text-muted-foreground">
              No items in inbox. Flag papers from any concept to add them here.
            </p>
          )}
        </div>
      )}
    </div>
  );
}
